import React from "react";

const ResultsList = ({
  results,
  highlightedBuilding,
  setSelectedBuilding,
  loadMoreData, // optional callback if the list wants to trigger additional loading
}) => {
  if (!results || results.length === 0) {
    return <p>No results found</p>;
  }

  return (
	  <div className="results-list">
		{results  .sort((a, b) => {
			if (highlightedBuilding && a.BuildingID === highlightedBuilding) return -1;  // Highlighted first
			if (highlightedBuilding && b.BuildingID === highlightedBuilding) return 1;
			
			if (a.Priority === "high" && b.Priority !== "high") return -1; // Featured next
			if (b.Priority === "high" && a.Priority !== "high") return 1;

			return 0; // Everything else remains as-is
		  })
		  .map((building, index) => {
		  if (!building || !building.BuildingID) {
			console.error("Invalid building data:", building);
			return null;
		  }
		  return (
			<div
			  key={building.BuildingID || `fallback-${index}`}
			  className={`listing-card ${highlightedBuilding === building.BuildingID ? "highlighted" : ""}`}
			  onClick={() => setSelectedBuilding(building)}
			>
			  {building.ImageURL && (
				<img
				  src={building.ImageURL}
				  alt={`Building ${building.BuildingID}`}
				  className="listing-image"
				/>
			  )}
			  <div className="listing-info">
				<h4>{building.Address || "Unknown Address"}</h4>
				<p>{building.City}, {building.State}</p>
				<p>Rent: ${building.MinRent ?? "N/A"} - ${building.MaxRent ?? "N/A"}</p>
				<p>{building.AvailableOffers ?? 0} Offers Available</p>
				{building.Priority === "high" && <span className="priority-badge">🌟 Best Fits</span>}
			  </div>
			</div>
		  );
		})}
	  </div>
	);
};

export default ResultsList;
